import { createFileRoute } from '@tanstack/react-router';

import { requirePermission } from '@/app/guards';
import { PolicyCreatePage, policyNewSearchSchema } from '@/features/policies';

export const Route = createFileRoute('/_authed/_active/s/$storeId/settings/policies/new')({
  validateSearch: policyNewSearchSchema,
  staticData: { crumb: 'policies:new' },
  beforeLoad: ({ context }) => {
    requirePermission(context.me, 'content.write');
  },
  component: PolicyCreatePage,
});
